import * as React from "react";
import homeImage from "../assets/Banner.png";

export function IconCloudDemo() {
  return (
    <>
      <div className="relative hidden sm:block w-full lg:w-1/2">
        <div className="relative sm:top-36 sm:right-20 flex items-center justify- overflow-hidden rounded-full sm:px-20 sm:pb-20 sm:pt-8">
          <img
            src={homeImage}
            alt="title"
            className="w-10/12 "
          />
        </div>
      </div>
    </>
  );
}
